import React from "react";
import { Chip, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit } from "@mui/icons-material";

const MenuItemTable = ({ menuItems, onEdit, isLoading }) => {

  const columns = [
    { field: "_id", headerName: "ID", width: 80, hide: true },
    { field: "item_name", headerName: "Item Name", width: 180 },
    {
      field: "price",
      headerName: "Price",
      width: 120,
      valueGetter: (params) => `₹ ${params.row.price?.toFixed(2) || "0.00"}`,
    },
    { field: "category", headerName: "Category", width: 140 },

    // ✅ Correctly display the status
    {
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => {
        const isActive = params.row.status === true;
        return (
          <Chip
            label={isActive ? "Active" : "Inactive"}
            color={isActive ? "success" : "default"}
            variant="outlined"
            sx={{ fontWeight: 600 }}
          />
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => (
        <IconButton onClick={() => onEdit(params.row)} color="primary">
          <Edit />
        </IconButton>
      ),
    },
  ];

  return (
    <DataGrid
      rows={menuItems}
      columns={columns}
      getRowId={(row) => row._id}
      disableSelectionOnClick
      autoHeight
      pageSize={10}
      rowsPerPageOptions={[10, 25, 50]}
      loading={isLoading}
    />
  );
};

export default MenuItemTable;
